import React from 'react';
import Helmet from 'react-helmet';
import { Button } from '@components';
import { useLocation, useNavigate } from 'react-router-dom';
import { Contato } from './components/contato';

export const FaleComSetorEmprestimoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      <Helmet>
        <title>Forluz - Fale conosco</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Fale conosco</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <Contato state={location.state} />
        </div>
      </div>
    </>
  );
};
